import {Cascader, Form, message} from 'antd'
import {SDrawerOrModal, SGeneralForms} from "shj-components";
import {useSetState} from "ahooks";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {orgPermissionsSave, orgPermissionsUpdate} from "@/services/saleOpServices.ts";
import {useEffect} from "react";
import {findOrgList} from "@/services/externalPerson.ts";
import {getParentId} from "@/utils/common.ts";

export const AddOrEditDom = (props) => {
  const {open, setOpen, record, reload, company} = props;
  const [form] = Form.useForm()
  const [state, setState] = useSetState<any>({
    loading: false,
  })

  useEffect(() => {
    if(open && record.id){
      // console.log(company)
      if(company?.length) {
        const ids = getParentId(company, record.orgId)?.reverse()
        form.setFieldsValue({...record, orgId: ids})
      }
    }
    return () => {
      form.resetFields()
    }
  }, [open, record, company]);

  const getOptions = async () => {
    setState({loading: true})
    const pageEnums = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.clue.PageEnum')
    // const company = await findOrgList()
    setState({loading: false})
    return Promise.resolve({company, pageEnums})
  }

  const onFinish = () => {
    form.validateFields().then(values => {
      setState({loading: true})
      const apiFn = values.id  ? orgPermissionsUpdate : orgPermissionsSave
      apiFn({...values, orgId: values.orgId[values.orgId?.length - 1]}).then(res => {
        message.success(res.message || '操作成功')
        reload()
        setOpen(false)
      }).finally(() => setState({loading: false}))
    })
  }

  return <SDrawerOrModal
      title={record?.id ? '编辑' : '新增'}
      open={open}
      onOk={onFinish}
      onCancel={() => setOpen(false)}
      loading={state.loading}
      width={500}
      mode={'modal'}
  >
    <SGeneralForms
        layout={'vertical'}
        formConfig={{form}}
        httpOptionsFn={getOptions}
        configs={[{
          formItem: [
            {label: 'id', name: 'id', hidden: true},
            {
              spanCol: 24,
              label: '组织',
              name: 'orgId',
              required: true,
              rules: [{required: true, message: '组织不能为空'}],
              children: <Cascader
                  showSearch
                  changeOnSelect
                  expandTrigger={'hover'}
                  placeholder={'请选择组织'}
                  options={company}
                  fieldNames={{label: 'label', value: 'id'}}
              />,
            },
            {
              spanCol: 24,
              label: '列表',
              name: record?.id ? 'page' : 'pages',
              required: true,
              rules: [{required: true, message: '列表不能为空'}],
              type: 'select',
              data: 'pageEnums',
              comConfig: {
                mode:  !record?.id && 'multiple',
                fieldNames: {label: 'description', value: 'key'}
              }
            },
          ]
        }]}/>
  </SDrawerOrModal>
}